<!--<a class="btn btn-sm btn-outline-default" type="button" *ngIf="showButton" (click)="this.openModal()">
    <i class="bi bi-bell"></i>
</a>-->


<!-- Modal -->
<div class="modal fade" bsModal #ruleModal="bs-modal" tabindex="-1" role="dialog" (onHidden)="closeModal()">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <b>Alarm Editor</b>
                <small>Build a set of rules to evaluate in real-time.</small>                
                <button (click)="addNewAlarm()" class="btn btn-sm btn-outline-default pull-right" [disabled]="alarms == null || alarms.length >= 3" type="submit"><i class="fa fa-plus"></i> Add New Alarm</button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12" *ngIf="alarms == null || alarms.length == 0">
                        No Alarms Configured
                    </div>
                    <div class="col-lg-12" *ngIf="alarms && alarms.length > 0">
                        <tabset #tabs>
                            <tab *ngFor="let alarm of alarms"
                                [heading]="alarm.name == null ? 'Not Set' : alarm.name"
                                [removable]="true"
                                (removed)="removeAlarm(alarm)">
                                <div class="row">
                                    <div class="col-lg-12 mt-3">
                                        <div class="row">
                                            <div class="col-lg-4">
                                                <b>Alarm Name</b>                                        
                                                <div class="input-group m-b">
                                                    <input type="text" class="form-control" [(ngModel)]="alarm.name" [ngClass]="{'is-invalid':alarm.name == null || alarm.name == ''}">
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <b>Created By</b>
                                                <div class="input-group-text m-b">
                                                    {{alarm.createdBy}}
                                                </div>                                       
                                            </div>
                                            <div class="col-lg-4">
                                                <b>Created Date</b>                                        
                                                <div class="input-group-text m-b">
                                                    {{alarm.createdDate}}
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <b>Distribution List</b>                                        
                                                <div class="input-group m-b">
                                                    <select [(ngModel)]="alarm.distributionListId" class="form-select" [ngClass]="{'is-invalid':alarm.distributionListId == null}">
                                                        <option *ngFor="let dl of distributionLists" [value]="dl.distributionListId">{{dl.listName}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <b>Message Template</b>                                        
                                                <div class="input-group m-b">
                                                    <select [(ngModel)]="alarm.messageTemplateId" class="form-select">
                                                        <option selected="selected" [ngValue]="null">None</option>
                                                        <option *ngFor="let mt of messageTemplates" [ngValue]="mt.messageTemplateId">{{mt.templateName}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-lg-4">
                                                <div class="list-group mt-3">
                                                    <div class="list-group-item d-flex align-items-center">
                                                        <div class="flex-fill">
                                                        <div class="fw-bold">Require Ack</div>
                                                        <div class="small text text-opacity-50">In App Acknoledgement of Alarms</div>
                                                        </div>
                                                        <div>
                                                            <div class="form-check form-switch">
                                                                <input type="checkbox" class="form-check-input" id="requireAck" [(ngModel)]="alarm.requireAck">
                                                                <label class="form-check-label" for="requireAck"></label>
                                                            </div>                                        
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <div class="col-lg-12 mt-3">
                                        <div class="card">
                                            <div class="card-body">
                                                
                                                <table class="table table-striped">
                                                    <tr>
                                                        <th>Name <i>(First match sent as the message)</i></th>
                                                        <th width="300px">Rule</th>
                                                        <th width="100px"><button (click)="addNewRule(alarm)" class="btn btn-sm btn-outline-default pull-right" type="submit" [disabled]="alarm.alarmConfiguration.length >= 5"><i class="fa fa-plus"></i> Add Rule</button></th>
                                                    </tr>
                                                    <tr *ngFor="let rule of alarm.alarmConfiguration">
                                                        <td>
                                                            <input type="text" placeholder="Enter Name" class="form-control form-control" [ngClass]="{'is-invalid':rule.name == null || rule.name == ''}"  [(ngModel)]="rule.name" required/>
                                                        </td>
                                                        <td>
                                                            <div class="input-group">
                                                                <div class="input-group-text m-b">
                                                                    X
                                                                </div>   
                                                                
                                                                <select [(ngModel)]="rule.check" class="form-control form-select" [ngClass]="{'is-invalid':rule.check == null}">
                                                                    <option value="LessThan">&lt;</option>
                                                                    <option value="LessThanOrEqual">&lt;=</option>
                                                                    <option value="GreaterThan">&gt;</option>
                                                                    <option value="GreaterThanOrEqual">&gt;=</option>
                                                                    <option value="Equal">=</option>
                                                                    <option value="NotEqual">!=</option>
                                                                </select>
                                                                
                                                                <input type="number" class="form-control form-control-sm"  [(ngModel)]="rule.match" [ngClass]="{'is-invalid':!isNumber(rule)}"/>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="btn-group">
                                                                <button class="btn btn-outline-default" (click)="moveRuleUp(alarm,rule)" ><i class="fa fa-sort-up"></i></button>
                                                                <button class="btn btn-outline-default" (click)="moveRuleDown(alarm,rule)" ><i class="fa fa-sort-down"></i></button>
                                                                <button class="btn btn-outline-danger" (click)="removeRule(alarm,rule)" ><i class="fa fa-trash"></i></button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>

                                        
                                            </div>
                                            <div class="card-arrow">
                                                <div class="card-arrow-top-left"></div>
                                                <div class="card-arrow-top-right"></div>
                                                <div class="card-arrow-bottom-left"></div>
                                                <div class="card-arrow-bottom-right"></div>
                                              </div>
                                        </div>
                                    </div>  
                                </div>  
                            </tab>
                        </tabset>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-default" type="button" (click)="saveAlarms()" [disabled]="alarms == null || !validate()">Save</button>
                <button class="btn btn-default" type="button" (click)="closeModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>